import { Skeleton } from "@/components/ui/skeleton";

/**
 * Skeleton daftar kartu ujian — geometry match kartu asli (thumbnail,
 * judul, subteks, badge, footer) supaya swap skeleton → konten minim CLS.
 * Dipakai AllExamsSection (loading) & LazyAllExamsSection (next/dynamic
 * loading) — sebelumnya dua varian hand-rolled yang berbeda-beda.
 */
export function ExamListSkeleton({ count = 6 }: { count?: number }) {
  return (
    <div className="grid grid-cols-2 gap-3 sm:gap-4 xl:grid-cols-3">
      {Array.from({ length: count }).map((_, i) => (
        <div
          key={i}
          className="border-border/60 bg-card shadow-soft overflow-hidden rounded-2xl border [--soft-shadow-color:var(--border)]"
        >
          <Skeleton className="h-[110px] rounded-none sm:h-[150px]" />
          <div className="p-3 sm:p-3.5">
            <Skeleton className="mb-2 h-4 w-3/4" />
            <Skeleton className="bg-foreground/[0.04] mb-2 h-3 w-1/2" />
            <Skeleton className="mb-3 h-5 w-20" />
            <div className="border-border/60 border-t pt-2">
              <Skeleton className="bg-foreground/[0.04] h-3 w-full" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
